import { Component } from '@angular/core';

@Component({
  selector: 'app-fixed-sectors',
  templateUrl: './fixed-sectors.component.html',
  styleUrl: './fixed-sectors.component.scss'
})
export class FixedSectorsComponent {

}
